import type { ScreenerSubField } from "epsm-api-types/models";

export const getNestedName = (col: ScreenerSubField): string => {
	let name = col.name;
	let current = col;

	while (current.subFields?.length) {
		current = current.subFields[0];
		name = `${name}.${current.name}`;
	}

	return name;
};
